import React from 'react';
import { motion } from 'framer-motion';
import { User, Palette, Briefcase, LeafyGreen } from 'lucide-react';
export function ForWhoSection() {
  const audiences = [{
    icon: <User className="w-8 h-8" data-id="element-99" />,
    title: 'Principiantes',
    desc: 'Sin experiencia previa. Te guiamos desde cero.'
  }, {
    icon: <Palette className="w-8 h-8" data-id="element-100" />,
    title: 'Personas creativas',
    desc: 'Que buscan una nueva forma de expresión manual.'
  }, {
    icon: <Briefcase className="w-8 h-8" data-id="element-101" />,
    title: 'Emprendedoras',
    desc: 'Que quieren iniciar un negocio rentable desde casa.'
  }, {
    icon: <LeafyGreen className="w-8 h-8" data-id="element-102" />,
    title: 'Amantes de lo natural',
    desc: 'Que valoran lo hecho a mano y los ingredientes puros.'
  }];
  return <section className="py-20 bg-white" data-id="element-103">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-105">
          <h2 className="font-serif text-3xl md:text-4xl text-artisanal-brown font-bold mb-4" data-id="element-106">
            ¿Para quién es este programa?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-107">
          {audiences.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="text-center" data-id="element-108">
              <div className="mx-auto w-20 h-20 bg-artisanal-cream rounded-full flex items-center justify-center text-artisanal-sage mb-6 shadow-sm" data-id="element-109">
                {item.icon}
              </div>
              <h3 className="font-serif text-xl font-bold text-artisanal-brown mb-3" data-id="element-110">
                {item.title}
              </h3>
              <p className="font-sans text-artisanal-brown/70" data-id="element-111">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}